import { router } from '@inertiajs/react'
import type { Topic } from '../../types'

interface Props {
  topic: Topic
  teamId: number
}

export default function TopicSolvedRow({ topic, teamId }: Props) {
  const handleReopen = () => {
    router.post(`/teams/${teamId}/topics/${topic.id}/reopen`, {}, { preserveScroll: true })
  }
  const resolvedDate = topic.resolved_at
    ? new Date(topic.resolved_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : null

  return (
    <div className="flex items-center gap-3 px-4 py-3 bg-white border border-stone rounded-lg">
      <svg className="w-5 h-5 text-[#15532E] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-text-primary line-through">{topic.title}</p>
        {topic.resolution_notes && (
          <p className="text-sm text-text-secondary truncate mt-0.5">{topic.resolution_notes}</p>
        )}
        {topic.created_at && (
          <p className="text-xs text-text-muted mt-0.5">
            Created {new Date(topic.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
          </p>
        )}
      </div>

      {resolvedDate && (
        <span className="text-sm text-text-muted flex-shrink-0">{resolvedDate}</span>
      )}

      <button
        type="button"
        onClick={handleReopen}
        className="text-sm font-medium text-text-secondary hover:text-text-primary underline flex-shrink-0"
      >
        Reopen
      </button>

      {topic.owner && (
        <div
          className="w-7 h-7 rounded-full bg-charcoal/60 text-white text-sm font-bold flex items-center justify-center flex-shrink-0"
          title={`${topic.owner.first_name} ${topic.owner.last_name}`}
        >
          {topic.owner.first_name?.charAt(0)}{topic.owner.last_name?.charAt(0)}
        </div>
      )}
    </div>
  )
}
